export default {
      id: "common__info1-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__info1",
      toString: function () {
        return this.url;
      }
    }